// The page title, subtitle and primary actions render inside the fixed header,
// but stay owned by the page that declares them — MoopPageHeader portals them
// into these two slots so click handlers, tour targets and page state stay put.
export const HEADER_TITLE_SLOT_ID = 'moop-header-title-slot';
export const HEADER_ACTIONS_SLOT_ID = 'moop-header-actions-slot';
